import { atom } from "jotai";

/**
 * Atom to control how images are loaded on the page.
 * "lazy" - Images load only when visible (default)
 * "eager" - Images load immediately (for printing)
 */
export const imageLoadingStrategyAtom = atom<"lazy" | "eager">("lazy");
